<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          v-model="entry.sourceStockId"
          v-bind="getObject('sourceStockId')"
          label="Estoque de Origem"
          :items="extraData.accountContext.allStocks"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <StockNew
              :inlineAddButton="true"
              @entry-created="sourceStockCreated"
              modelNameSingular="Estoque de Origem"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          v-model="entry.targetStockId"
          v-bind="getObject('targetStockId')"
          label="Estoque de Destino"
          :items="extraData.accountContext.allStocks"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <StockNew
              :inlineAddButton="true"
              @entry-created="targetStockCreated"
              modelNameSingular="Estoque de Destino"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <DateField
          :inputData.sync="entry.transferDate"
          v-bind="getObject('transferDate')"
          label="Data da Transferência"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.sourceStockId">
        <StockTransferItemsIndex
          :stockTransferItems="entry.stockTransferItemsAttributes"
          :stockTransfer="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
        />
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.observation"
          v-bind="getObject('observation')"
          label="Observações"
          autocomplete="off"
          outlined
          :disabled="readOnly"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue";
import StockTransferItemsIndex from "@models/stocks/stock_transfers/stock_transfer_items/index.vue";
import StockNew from "@models/stocks/new.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    StockTransferItemsIndex: StockTransferItemsIndex,
    StockNew: StockNew,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    sourceStockCreated: function(stock) {
      this.extraData.accountContext.allStocks.unshift(stock);
      this.entry.sourceStockId = stock.id;
      this.entry.sourceStock = stock;
    },
    targetStockCreated: function(stock) {
      this.extraData.accountContext.allStocks.unshift(stock);
      this.entry.targetStockId = stock.id;
      this.entry.targetStock = stock;
    },
  }
};
</script>

<style scoped></style>
